<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="row justify-content-center mt-2">
  <div class="col-lg-11">
    <div class="card-wrapper card-space">
      <div class="card-body">
        <div class="card card-bg card-big">
          <div class="d-flex mt-2 justify-content-center mb-5">
            <div class="d-flex align-items-center mb-3">
              <svg class="icon icon-danger">
                <use href="./content/svg/sprites.svg#it-warning-circle"></use>
              </svg>
              <span class="h5 mb-0 px-1 fw-bold text-uppercase">INTEGRAZIONE PAGAMENTI</span>
            </div>
          </div>
          <div class="container container-lg">
            <div>
              <!-- Lista pagamenti dettaglio istanza -->
              <div class="row justify-content-center mb-5 pb-5">
                <div *ngIf="istanzaCorrente?.integrazioni?.[0]?.pagamenti?.length" class="col-lg-12">
                  <h4 class="text-center fw-bold mb-5" jhiTranslate="istanze.listaPagamenti">Lista pagamenti</h4>
                  <div class="card-wrapper d-flex justify-content-center" style="padding-bottom: 0">
                    <div class="card card-bg border-bottom-card">
                      <div class="card-body">
                        <div class="table-responsive" style="overflow-x: hidden">
                          <table class="table table-striped">
                            <caption hidden>Tabella lista pagamenti</caption>
                            <thead>
                            <tr>
                              <th scope="col" class="text-center">ID</th>
                              <th scope="col" class="text-center">Causale</th>
                              <th scope="col" class="text-center">Importo</th>
                              <th scope="col" class="text-center">Stato</th>
                              <th scope="col" class="text-center">Data del pagamento</th>
                              <th scope="col" class="text-center">Data scadenza</th>
                              <th scope="col" class="text-center" style="width: 25%">Azioni</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let pg of istanzaCorrente?.integrazioni?.[0]?.pagamenti; index as i">
                              <td class="text-center">{{ pg.id }}</td>
                              <td class="text-center">{{ pg.causale?.descrizione}}</td>
                              <td class="text-center">{{ pg.importo | currency: 'EUR' }}</td>
                              <td class="text-center">{{ mapStatiPagamento.get(pg.stato)?.testo }}</td>
                              <td class="text-center"
                                  *ngIf="pg.dataPagamento">{{
                                  formatDate(pg.dataPagamento).toLocaleString(this.selectedLanguage!.toString(), {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                  })
                                }}
                              </td>
                              <td class="text-center" *ngIf="!pg.dataPagamento">In attesa del pagamento</td>
                              <td *ngIf="pg.dataScadenza" class="text-center">{{ formatDateNormal(pg.dataScadenza) }}
                              </td>
                              <td *ngIf="!pg.dataScadenza" class="text-center ">-</td>
                              <td *ngIf="pg.stato === '00'" class="position-relative">
                                <div class="d-flex justify-content-around">
                                  <button class="button c-pointer primary-button"
                                          (click)="goToPagamento(istanzaCorrente?.istanza, pg.id)">
                                    <div class="button-wrapper position-relative">
                                      <div class="text fw-bold" jhiTranslate="pagamenti.paga">Paga</div>
                                      <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-primary grow" id="Icons"
                                   viewBox="0 0 32 32">
                          <style type="text/css">
                            .st0 {
                              fill: none;
                              stroke: white;
                              stroke-width: 2;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                            }

                            .st3 {
                              fill: none;
                            }
                          </style>
                          <path class="st0"
                                d="M19.7,26.8c-0.9-0.9-1.1-2.2-0.7-3.3l-3.3-3.3c-1.6-1.6-1.5-4.4,0.3-6.2l0,0l5,5" />
                          <path class="st0" d="M12.7,26.3c0.6,0.7,1.3,1.3,2.1,1.7c0.7,0.4,1.2,1.2,1.2,2v0" />
                          <path class="st0" d="M18,24H8c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13" />
                          <line class="st0" x1="10" y1="3" x2="10" y2="24" />
                          <line class="st0" x1="16" y1="6" x2="16" y2="10" />
                          <path class="st0" d="M25,30v-9.5c0-3.3-2-6.2-5-7.4" />
                          <rect x="-144" y="-216" class="st3" width="536" height="680" />
                        </svg>
                            </span>
                                    </div>
                                  </button>
                                  <button class="button primary-button fw-bold ms-2" style="width: 200px" type="button"
                                          *ngIf="pg.avvisoPagopa"
                                          (click)="scaricaAvviso(pg.avvisoPagopa)">
                                    <div class="button-wrapper position-relative">
                                      <div class="text fw-bold">Scarica avviso</div>
                                      <span class="icon-download">
                                                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                                                 role="img" width="10px"
                                                                 height="10px" preserveAspectRatio="xMidYMid meet"
                                                                 viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path>
                          <style type="text/css">
                            .st0 {
                              fill: none;
                              stroke: white;
                              stroke-width: 2;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                            }

                            .st3 {
                              fill: none;
                            }
                          </style>
                        </svg>
                            </span>
                                    </div>
                                  </button>
                                </div>
                              </td>
                              <td class="fw-bold text-center" *ngIf="pg.stato === '01'">
                                Pagato
                              </td>
                              <td class="fw-bold text-center" *ngIf="pg.stato === '10'">
                                Annullato
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-primary btn-sm" (click)="goBack()">
                <svg class="icon icon-sm icon-white">
                  <use href="./content/svg/sprites.svg#it-arrow-left"></use>
                </svg>
                <span jhiTranslate="istanze.indietro" class="text-uppercase">INDIETRO</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
